<template lang="pug">
b-modal#updateProfileSetting(
  ref="updateProfileSetting"
  :title="$t('ui.combine.update_profile_setting')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    template(v-if="['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(setting_key)")
      b-form-group(
        :label="$t('ui.' + setting_key_display, { currency: getCurrencyCode })"
        label-cols="10"
        ).mb-2
        .d-flex.mt-2
          label.custom-switch
            input.custom-switch-input(
              type="checkbox"
              required
              :dirty="$v.setting_value_aff.$dirty"
              :error="$v.setting_value_aff.$error"
              v-model.trim.lazy="$v.setting_value_aff.$model"
              :disabled="loading"
            )
            span.custom-switch-indicator
        ValidateResult(:value="$v.setting_value_aff" :name="$tc('ui.value', 1)")
    template(v-else)
      b-form-group(:label="$t('ui.' + setting_key_display, { currency: getCurrencyCode })").mb-0
        DebounceInput(
          size="sm"
          ref="setting_value"
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
        template(v-if="['free_coin_min_withdrawal'].includes(setting_key)")
          span.small.text-info {{ $t("message.tooltips_free_point", { currency: getCurrencyCode, point: exchangePointRate }) }}
        ValidateResult(:value="$v.setting_value" :name="$tc('ui.value', 1)" :fvalue="'0'")
    b-form-group(:label="$t('ui.date')" v-if="setting_key == 'maintenance' && setting_value_aff == 1").mb-0
      DateTimeRangePicker(:value="dateRangeSlots" @update="getDataSlots" ref="dateRangeSlots" :removePrepend="true" :displayClearButton="true")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import TurnoverRebate from "@/library/TurnoverRebate";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
import DateTimeRangePicker from "@/library/DateTimeRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    TurnoverRebate,
    DateTimeRangePicker
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
    exchangePointRate: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      setting_key: "",
      setting_key_display: "",
      setting_value: 0,
      setting_value_aff: false,
      loading: false,
      start_date: null,
      end_date: null,
      dateRangeSlots: {
        startDate: null,
        endDate: null,
      },
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWithTime() {
      let time = '00:00:00';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    tomorrow() {
      return this.$moment(new Date).add(1, 'days').format('YYYY-MM-DD');
    },
    tomorrowWithTime() {
      let time = '00:00:00';
      return this.$moment(this.tomorrow+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  validations: {
    setting_value: {
      required: requiredIf(function () {
        return !['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(this.setting_key);
      }),
      validType(value) {
        // allow empty if not required
        if (!value) return true
        if (['daily_withdrawal_frequency','vip_cycle_day','free_coin_signup', 'free_coin_daily','free_coin_min_withdrawal','free_coin_per_unit'].includes(this.setting_key)) {
          // must be integer
          return /^[0-9]+$/.test(value)
        }
        // other keys: accept anything (string/number/etc.)
        return true
      },
      mustMoreThan: function(value) {
        if(['inbox_valid_day'].includes(this.setting_key) && parseFloat(value) <= 0 ) return false
        return true
      }
    },
    setting_value_aff: {
      required: requiredIf(function () {
        return ['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(this.setting_key);
      })
    }
  },
  methods: {
    getDataSlots(currentValue) {
      if(currentValue == null) return
      this.dateRangeSlots.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRangeSlots.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.globalSettingUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          setting_key: this.item.setting_key
        };

        if(['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(this.item.setting_key)) {
          json.setting_value = this.setting_value_aff ? 1 : 0
          if(this.item.setting_key == 'maintenance') {
            json.remark = this.dateRangeSlots.startDate
            json.remark2 = this.dateRangeSlots.endDate
          }
        } else {
          json.setting_value = this.setting_value
        }

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updateProfileSetting.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "update_profile_setting", this.feedback.status);
                  this.$refs.updateProfileSetting.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {

      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.setting_key = this.item.setting_key;
      if(['min_deposit','min_withdrawal','max_withdrawal'].includes(this.setting_key)) {
        if(this.setting_key == 'min_deposit') {
          this.setting_key_display = 'minimum_deposit'
        } else if(this.setting_key == 'min_withdrawal') {
          this.setting_key_display = 'minimum_withdrawal'
        } else if(this.setting_key == 'max_withdrawal') {
          this.setting_key_display = 'maximum_withdrawal'
        }
      } else {
        this.setting_key_display = this.setting_key
      }

      if(['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(this.setting_key)) {
        this.setting_value_aff = this.item.setting_value;
        if(this.setting_key == 'maintenance') {
          this.start_date = this.todayWithTime;
          this.end_date = this.tomorrowWithTime;
          this.getDataSlots({
            startDate: this.start_date,
            endDate: this.end_date
          });
        }
      } else {
        this.setting_value = this.item.setting_value;
        // this.$refs.setting_value.$el.focus();
      }
    }
  }
};
</script>
